import { API_BASE_URL } from '../services/api';

/**
 * Normaliza e retorna a URL completa de uma imagem.
 * Resolve discrepâncias entre caminhos locais, banco de dados e URLs de produção.
 */
export const getImageUrl = (path: string | undefined | null): string => {
  if (!path) return '';
  
  // Se for URL externa (Unsplash, etc), retorna direto
  if (path.startsWith('http')) return path;
  
  // Garante que o caminho comece com /
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  
  // Normaliza a baseUrl da API
  // Se a baseUrl for '/api' ou 'https://.../api', queremos apenas a parte da API
  // Mas queremos evitar que o '/public' vaze para a URL final
  let baseUrl = API_BASE_URL;
  
  // Remove '/api' do final se existir, para que possamos reconstruir o caminho de uploads
  // que geralmente é mapeado como /api/uploads no servidor ou apenas /uploads
  baseUrl = baseUrl.replace(/\/api\/?$/, '');
  
  // Se a URL final contiver /public, removemos, pois o Apache já deve estar apontando para lá
  const finalUrl = `${baseUrl}${cleanPath}`.replace('/public/', '/');
  
  return finalUrl;
};
